import { useState } from "react";
import "./ContractOverview.scss";

export default function ContractOverview() {
  const [dateRange] = useState("01.10.2026 bis 28.10.2026");
  const [dateMode, setDateMode] = useState("vertragsbeginn");
  const [tarif, setTarif] = useState("alle");
  const [kunde, setKunde] = useState("alle");
  const [vvlStatus, setVvlStatus] = useState("alle");

  function handleShow() {
    // Filter-Logik würde hier implementiert werden
  }

  function handleReset() {
    setDateMode("vertragsbeginn");
    setTarif("alle");
    setKunde("alle");
    setVvlStatus("alle");
  }

  return (
    <main className="contract-overview" aria-labelledby="contract-overview-title">
      <header className="contract-overview__header">
        <h1 id="contract-overview-title">Vertragsübersicht und Export</h1>
        <p>Alle Verträge im Überblick – mit Filtern und Exportfunktion.</p>
      </header>

      <div className="contract-overview__columns">
        <section className="contract-overview__card" aria-labelledby="contract-overview-table-heading">
          <h2 id="contract-overview-table-heading">Verträge</h2>

          <div className="contract-overview__table-wrapper">
            <table className="contract-overview__table">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" aria-label="Alle auswählen" />
                  </th>
                  <th scope="col">Edit</th>
                  <th scope="col">Kunde</th>
                  <th scope="col">Aktivierung</th>
                  <th scope="col">
                    Erfassung <span aria-hidden="true">↑</span>
                  </th>
                  <th scope="col">Vertragsbeginn</th>
                  <th scope="col">HandyNr</th>
                  <th scope="col">Tarif / Artikel</th>
                  <th scope="col">Netzbetreiber</th>
                  <th scope="col">Typ</th>
                  <th scope="col">K-Gruppe</th>
                  <th scope="col">Vertragsende</th>
                  <th scope="col">VVL</th>
                  <th scope="col">Status</th>
                  <th scope="col">Del</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" aria-label="Zeile auswählen" />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="contract-overview__icon-btn"
                      aria-label="Bearbeiten"
                    >
                      ✎
                    </button>
                    <button
                      type="button"
                      className="contract-overview__icon-btn"
                      aria-label="Info"
                    >
                      ⓘ
                    </button>
                  </td>
                  <td>
                    <a href="#" className="contract-overview__link">
                      Dietrich, Sandra
                    </a>
                  </td>
                  <td>18.10.2026</td>
                  <td>15.01.2022</td>
                  <td>01512345678</td>
                  <td>Tarif 2 NB3</td>
                  <td>Netzbetreiber 3</td>
                  <td>Credit</td>
                  <td></td>
                  <td>15.01.2024</td>
                  <td>15.10.2023</td>
                  <td>
                    <span className="contract-overview__status contract-overview__status--active">
                      Aktiv
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="contract-overview__icon-btn contract-overview__icon-btn--danger"
                      aria-label="Löschen"
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <aside className="contract-overview__card" aria-label="Filter">
          <h2>Filter</h2>

          <div className="contract-overview__filter">
            <label className="contract-overview__filter-label">Für Zeitraum</label>
            <div className="contract-overview__filter-value">{dateRange}</div>
          </div>

          <div className="contract-overview__filter">
            <label className="contract-overview__filter-label" htmlFor="contract-overview-date-mode">
              Erfassung | Vertragsbeginn
            </label>
            <select
              id="contract-overview-date-mode"
              className="contract-overview__select"
              value={dateMode}
              onChange={(event) => setDateMode(event.target.value)}
            >
              <option value="erfassung">Erfassung</option>
              <option value="vertragsbeginn">Vertragsbeginn</option>
            </select>
          </div>

          <div className="contract-overview__filter">
            <label className="contract-overview__filter-label" htmlFor="contract-overview-tarif">
              Tarif
            </label>
            <select
              id="contract-overview-tarif"
              className="contract-overview__select"
              value={tarif}
              onChange={(event) => setTarif(event.target.value)}
            >
              <option value="alle">Alle</option>
              <option value="tarif1">Tarif 1</option>
              <option value="tarif2">Tarif 2</option>
              <option value="tarif3">Tarif 3</option>
            </select>
          </div>

          <div className="contract-overview__filter">
            <label className="contract-overview__filter-label" htmlFor="contract-overview-kunde">
              Kunde
            </label>
            <select
              id="contract-overview-kunde"
              className="contract-overview__select"
              value={kunde}
              onChange={(event) => setKunde(event.target.value)}
            >
              <option value="alle">Alle</option>
            </select>
          </div>

          <div className="contract-overview__filter">
            <label className="contract-overview__filter-label" htmlFor="contract-overview-vvl-status">
              VVL-Status
            </label>
            <select
              id="contract-overview-vvl-status"
              className="contract-overview__select"
              value={vvlStatus}
              onChange={(event) => setVvlStatus(event.target.value)}
            >
              <option value="alle">Alle</option>
              <option value="aktiv">Aktiv</option>
              <option value="inaktiv">Inaktiv</option>
            </select>
          </div>

          <div className="contract-overview__filter-actions">
            <button
              type="button"
              className="contract-overview__btn contract-overview__btn--show"
              onClick={handleShow}
            >
              Anzeigen
            </button>
            <button
              type="button"
              className="contract-overview__btn contract-overview__btn--reset"
              onClick={handleReset}
            >
              Zurücksetzen
            </button>
          </div>
        </aside>
      </div>
    </main>
  );
}
